import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  dark?: boolean;
}
export function Section({
  children,
  className = '',
  id,
  dark = false
}: SectionProps) {
  return <section id={id} className={`${`${`${`py-16 md:py-24 ${dark ? 'bg-navy-900 text-white' : 'bg-slate-50 text-slate-900'} ${className}`} pt-[20px] pb-[20px]`} pt-[20px] pb-[20px]`} pt-[20px] pb-[20px]`} data-id="element-329">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.6,
      ease: 'easeOut'
    }} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-330">
        {children}
      </motion.div>
    </section>;
}